export default __webpack_public_path__ + "b852f05204267a00355adc3284d6fd01.png";